import { Box, Grid, useMediaQuery, useTheme } from '@material-ui/core';
import OffreItem from 'components/OffresBlock/Item';
import messages from 'components/OffresBlock/messages';
import { OffreItemProp } from 'components/OffresBlock/types';
import {
  PREVENTION_AUTO_LINK,
  PREVENTION_MRH_LINK,
  PRODUCT_ASSUR_AUTO_RABEH_LINK,
  PRODUCT_WAQET_OU_ZMANE_LINK,
} from 'constants/externalLinks';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import { AssuranceIcon } from 'images';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Carousel } from 'react-responsive-carousel';
import { getLocale } from 'store/LanguageProvider/selectors';
import { StyledCarouselContainer } from './style';

const OffreBlock = () => {
  const language = useSelector(getLocale);
  const { formatMessage } = useIntl();
  const items: OffreItemProp[] = [
    {
      backgroundImage: AssuranceIcon.offreAuto1,
      title: formatMessage({ ...messages.title_offre1 }),
      body: formatMessage({ ...messages.content_offre1 }),
      ctaText: formatMessage({ ...messages.buttonLabel_offre1 }),
      link: PRODUCT_ASSUR_AUTO_RABEH_LINK[language],
      category: EVENT_CATEGORIES.OFFRES_CONSEILS,
      label: "Assur'Auto Rabe7 _En savoir plus",
    },
    {
      backgroundImage: AssuranceIcon.offreAuto2,
      title: formatMessage({ ...messages.title_offre2 }),
      body: formatMessage({ ...messages.content_offre2 }),
      ctaText: formatMessage({ ...messages.buttonLabel_offre2 }),
      link: PREVENTION_AUTO_LINK[language],
      category: EVENT_CATEGORIES.OFFRES_CONSEILS,
      label: 'Prévention routière _Téléchargez le guide',
    },
    {
      backgroundImage: AssuranceIcon.offreAuto3,
      title: formatMessage({ ...messages.title_offre3 }),
      body: formatMessage({ ...messages.content_offre3 }),
      ctaText: formatMessage({ ...messages.buttonLabel_offre3 }),
      link: PRODUCT_WAQET_OU_ZMANE_LINK[language],
      category: EVENT_CATEGORIES.OFFRES_CONSEILS,
      label: 'Lwoqt ou Zmane_En savoir plus',
    },
    {
      backgroundImage: AssuranceIcon.offreAuto4,
      title: formatMessage({ ...messages.title_offre4 }),
      body: formatMessage({ ...messages.content_offre4 }),
      ctaText: formatMessage({ ...messages.buttonLabel_offre4 }),
      link: PREVENTION_MRH_LINK[language],
      category: EVENT_CATEGORIES.OFFRES_CONSEILS,
      label: 'Conseils prévention Habitation_En savoir plus',
    },
  ];

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const Parent = matches ? Carousel : Grid;
  const Container = matches ? StyledCarouselContainer : React.Fragment;

  return (
    <Box marginBottom={4}>
      <Container>
        <Parent
          {...(matches
            ? { className: 'direction' }
            : { container: true, justify: 'space-between' })}
        >
          {items &&
            items.map((item, index) => {
              return <OffreItem {...item} key={index}></OffreItem>;
            })}
        </Parent>
      </Container>
    </Box>
  );
};

export default OffreBlock;
